export const WORKER_MESSAGE_TASK_QUEUED_SUCCESSFULLY =
  "Task added to the queue successfully for asynchronous processing";

export const WORKER_MESSAGE_BOOK_GENERATED_SUCCESSFULLY =
  "The book has been generated successfully";

export const WORKER_ERROR_MESSAGE_INVALID_TASK_ID = "Invalid task id";

export const WORKER_MESSAGE_CHAPTER_GENERATED_SUCCESSFULLY =
  "The chapter has been generated successfully";

export const WORKER_ERROR_MESSAGE_ON_STATUS_CHANGE_CALLBACK_NOT_REGISTERED =
  "onStatusChange callback is not registered for the worker";
